"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GovernanceAccountType = exports.getCommunityMintFromRealm = exports.getRealmFromGovernance = exports.getVoteRecordAddress = exports.getTokenOwnerRecordAddress = exports.pubkeyFilter = exports.MemcmpFilter = exports.GOVERNANCE_PROGRAM_ID = exports.GOVERNANCE_PROGRAM_SEED = void 0;
const web3_js_1 = require("@solana/web3.js");
// Not include the directly package because of
// https://github.com/solana-labs/oyster/issues/538
exports.GOVERNANCE_PROGRAM_SEED = 'governance';
exports.GOVERNANCE_PROGRAM_ID = new web3_js_1.PublicKey('GovER5Lthms3bLBqWub97yVrMmEogzX7xNjdXpPPCVZw');
class MemcmpFilter {
    constructor(offset, bytes) {
        this.offset = offset;
        this.bytes = bytes;
    }
    isMatch(buffer) {
        if (this.offset + this.bytes.length > buffer.length) {
            return false;
        }
        for (let i = 0; i < this.bytes.length; i++) {
            if (this.bytes[i] !== buffer[this.offset + i])
                return false;
        }
        return true;
    }
}
exports.MemcmpFilter = MemcmpFilter;
const pubkeyFilter = (offset, pubkey) => (!pubkey ? undefined : new MemcmpFilter(offset, pubkey.toBuffer()));
exports.pubkeyFilter = pubkeyFilter;
// https://github.com/solana-labs/oyster/blob/b874111120397a4ad7c3c08798577f7a8cba46d7/packages/governance-sdk/src/governance/accounts.ts#L619
function getTokenOwnerRecordAddress(programId, realm, governingTokenMint, governingTokenOwner) {
    return __awaiter(this, void 0, void 0, function* () {
        const [tokenOwnerRecordAddress] = yield web3_js_1.PublicKey.findProgramAddress([
            Buffer.from(exports.GOVERNANCE_PROGRAM_SEED),
            realm.toBuffer(),
            governingTokenMint.toBuffer(),
            governingTokenOwner.toBuffer(),
        ], programId);
        return tokenOwnerRecordAddress;
    });
}
exports.getTokenOwnerRecordAddress = getTokenOwnerRecordAddress;
// https://github.com/solana-labs/oyster/blob/b874111120397a4ad7c3c08798577f7a8cba46d7/packages/governance-sdk/src/governance/accounts.ts#L1127
function getVoteRecordAddress(programId, proposal, tokenOwnerRecord) {
    return __awaiter(this, void 0, void 0, function* () {
        const [voteRecordAddress] = yield web3_js_1.PublicKey.findProgramAddress([Buffer.from(exports.GOVERNANCE_PROGRAM_SEED), proposal.toBuffer(), tokenOwnerRecord.toBuffer()], programId);
        return voteRecordAddress;
    });
}
exports.getVoteRecordAddress = getVoteRecordAddress;
function getRealmFromGovernance(connection, governance) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const governanceData = (_a = (yield connection.getAccountInfo(governance, 'single'))) === null || _a === void 0 ? void 0 : _a.data;
        if (!governanceData) {
            return new web3_js_1.PublicKey('');
        }
        const offset = 1;
        // https://github.com/solana-labs/oyster/blob/cb5b4e69fb95effbafdcfd429be1a598ed7a6fdd/packages/governance-sdk/src/governance/serialisation.ts#L745
        return new web3_js_1.PublicKey(governanceData.slice(offset, offset + 32));
    });
}
exports.getRealmFromGovernance = getRealmFromGovernance;
function getCommunityMintFromRealm(connection, realm) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const realmData = (_a = (yield connection.getAccountInfo(realm, 'single'))) === null || _a === void 0 ? void 0 : _a.data;
        if (!realmData) {
            return new web3_js_1.PublicKey('');
        }
        const offset = 1;
        // https://github.com/solana-labs/oyster/blob/cb5b4e69fb95effbafdcfd429be1a598ed7a6fdd/packages/governance-sdk/src/governance/serialisation.ts#L703
        return new web3_js_1.PublicKey(realmData.slice(offset, offset + 32));
    });
}
exports.getCommunityMintFromRealm = getCommunityMintFromRealm;
// https://github.com/solana-labs/oyster/blob/b874111120397a4ad7c3c08798577f7a8cba46d7/packages/governance-sdk/src/governance/accounts.ts#L14
var GovernanceAccountType;
(function (GovernanceAccountType) {
    GovernanceAccountType[GovernanceAccountType["Uninitialized"] = 0] = "Uninitialized";
    GovernanceAccountType[GovernanceAccountType["RealmV1"] = 1] = "RealmV1";
    GovernanceAccountType[GovernanceAccountType["TokenOwnerRecordV1"] = 2] = "TokenOwnerRecordV1";
    GovernanceAccountType[GovernanceAccountType["GovernanceV1"] = 3] = "GovernanceV1";
    GovernanceAccountType[GovernanceAccountType["ProgramGovernanceV1"] = 4] = "ProgramGovernanceV1";
    GovernanceAccountType[GovernanceAccountType["ProposalV1"] = 5] = "ProposalV1";
    GovernanceAccountType[GovernanceAccountType["SignatoryRecordV1"] = 6] = "SignatoryRecordV1";
    GovernanceAccountType[GovernanceAccountType["VoteRecordV1"] = 7] = "VoteRecordV1";
    GovernanceAccountType[GovernanceAccountType["ProposalInstructionV1"] = 8] = "ProposalInstructionV1";
    GovernanceAccountType[GovernanceAccountType["MintGovernanceV1"] = 9] = "MintGovernanceV1";
    GovernanceAccountType[GovernanceAccountType["TokenGovernanceV1"] = 10] = "TokenGovernanceV1";
    GovernanceAccountType[GovernanceAccountType["RealmConfig"] = 11] = "RealmConfig";
    GovernanceAccountType[GovernanceAccountType["VoteRecordV2"] = 12] = "VoteRecordV2";
    GovernanceAccountType[GovernanceAccountType["ProposalTransactionV2"] = 13] = "ProposalTransactionV2";
    GovernanceAccountType[GovernanceAccountType["ProposalV2"] = 14] = "ProposalV2";
    GovernanceAccountType[GovernanceAccountType["ProgramMetadata"] = 15] = "ProgramMetadata";
    GovernanceAccountType[GovernanceAccountType["RealmV2"] = 16] = "RealmV2";
    GovernanceAccountType[GovernanceAccountType["TokenOwnerRecordV2"] = 17] = "TokenOwnerRecordV2";
    GovernanceAccountType[GovernanceAccountType["GovernanceV2"] = 18] = "GovernanceV2";
    GovernanceAccountType[GovernanceAccountType["ProgramGovernanceV2"] = 19] = "ProgramGovernanceV2";
    GovernanceAccountType[GovernanceAccountType["MintGovernanceV2"] = 20] = "MintGovernanceV2";
    GovernanceAccountType[GovernanceAccountType["TokenGovernanceV2"] = 21] = "TokenGovernanceV2";
    GovernanceAccountType[GovernanceAccountType["SignatoryRecordV2"] = 22] = "SignatoryRecordV2";
    GovernanceAccountType[GovernanceAccountType["ProposalDeposit"] = 23] = "ProposalDeposit";
})(GovernanceAccountType = exports.GovernanceAccountType || (exports.GovernanceAccountType = {}));
